import { DashboardArticle } from './../../../models/article';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dashboard-article-card',
  templateUrl: './dashboard-article-card.component.html',
  styleUrls: ['./dashboard-article-card.component.scss']
})
export class DashboardArticleCardComponent {
  @Input() compact = false;
  @Input() article: DashboardArticle;
  @Input() showMutlipleImage: boolean = false;
}
